import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from '../Link';
export const SectionHeader = (param)=>{
    let { title, subtitle, showMorePath, rightElement } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-2 mb-4",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex bg-background justify-between text-muted-foreground",
                "data-e2e": "section-".concat(title.replace(' ', '-').toLowerCase()),
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "text-lg font-medium text-foreground",
                        children: title
                    }),
                    showMorePath && /*#__PURE__*/ _jsx(Link, {
                        "data-e2e": "show-more-".concat(title.replace(' ', '-').toLowerCase()),
                        className: 'white',
                        to: showMorePath,
                        children: "Show More"
                    }),
                    rightElement
                ]
            }),
            subtitle && /*#__PURE__*/ _jsx("div", {
                className: "text-sm font-normal text-muted-foreground",
                children: /*#__PURE__*/ _jsx("p", {
                    children: subtitle
                })
            })
        ]
    });
};
